
import { Component, Prop, Vue } from "vue-property-decorator";
import { IAssistanceService } from "@/entities";

@Component({
  name: "detail-assistance",
})
export default class DetailAssistance extends Vue {
  @Prop({ required: true })
  assistanceService!: IAssistanceService | undefined;

  constructor() {
    super();
  }
}
